/**
 * Auth callback path for bizeye hosts where top-level `/auth/*` is routed to the API gateway.
 * Cloudflare/ALB on bizeye.senrysa.in returns Nest 404 for `/auth/callback` before the SPA loads.
 */
export const AUTH_CALLBACK_PATH = "/app/auth/callback";

/** SPA path — top-level `/events` is routed to the API gateway on bizeye.senrysa.in. */
export const EVENTS_PAGE_PATH = "/dashboard/events";

/**
 * SPA paths — top-level `/member/*` is routed to the API gateway on bizeye.senrysa.in
 * (Nest "Cannot GET /member/edit/..." on refresh). Keep API calls at `/member/auth/*`.
 */
export const MEMBER_PAGE_PATH = "/dashboard/member";
export const MEMBER_CREATE_PATH = "/dashboard/member/create";
export const memberEditPath = (id: string) =>
  `/dashboard/member/edit/${encodeURIComponent(id)}`;
